import axios from 'axios';
import { Message } from 'element-gui';
import router from '@/router/index';
import util from '@/utils/crypto';
import md5 from 'js-md5';
import {VUE_APP_BASE_URL} from "@/utils/baseUrl";
// 基本配置

const instance = axios.create({
  baseURL:VUE_APP_BASE_URL,
  timeout: 0,
  withCredentials: false,
});

// 请求配置
instance.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    let data = config.data || config.params;
    if (data && !Array.isArray(data) && Object.keys(data).length) {
      config.headers['enc'] = `2_${util.encrypt(Object.keys(data).join('_'))}`;
      config.headers['sign'] = md5(
        Object.keys(data)
          .map(function (item) {
            return Object.prototype.toString.call(data[item]) ===
              '[object String]'
              ? data[item]
              : JSON.stringify(data[item]);
          })
          .join('')
      );
    } else {
      config.headers['sign'] = md5('enc');
    }
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    if (window.sessionStorage.getItem('token')) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = window.sessionStorage.getItem('token');
      let authorSubString = config.headers.Authorization.split('_').join('');
      let startKey = Math.ceil(Math.random() * authorSubString.length);
      let endKey = Math.ceil(Math.random() * authorSubString.length);
      if (endKey > startKey) {
        config.headers.token = util.encrypt(
          `${startKey}_${endKey}_${authorSubString.substring(
            startKey,
            endKey
          )}@${config.url}@${new Date().getTime()}`
        );
      } else {
        config.headers.token = util.encrypt(
          `${endKey}_${startKey}_${authorSubString.substring(
            endKey,
            startKey
          )}@${config.url}@${new Date().getTime()}`
        );
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 返回配置
instance.interceptors.response.use(
  (response) => {
    if (window.sessionStorage.getItem('token')) {
      if (response.data.code == '1101') {
        router.push({ path: '/login' });
        location.sessionStorage.clear()
      } else if (response.data.code == 1010) {
        return response.data;
      } else {
        if (
          !(response.data instanceof Object) ||
          response.headers['content-type'] === 'application/octet-stream'
        ) {
          //二进制流获取
          return response;
        } else {
          return response.data;
        }
      }
    } else {
      if (
        !(response.data instanceof Object) ||
        response.headers['content-type'] === 'application/octet-stream'
      ) {
        //二进制流获取
        return response;
      } else {
        return response.data;
      }
    }
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求';
          break;
        case 401:
          // error.message = '未授权，请重新登录';
          router.push({ path: '/login' });
          location.sessionStorage.clear();
          var body = document.getElementsByTagName('body')[0];
          var layer = document.querySelector('.layui-layer');
          if (layer) {
            body.removeChild(layer);
          }
          break;
        case 403:
          error.message = '拒绝访问';
          break;
        case 404:
          error.message = '请求错误,未找到该资源';
          break;
        case 405:
          error.message = '请求方法未允许';
          break;
        case 408:
          error.message = '请求超时';
          break;
        case 500:
          error.message = '服务器端出错';
          break;
        case 501:
          error.message = '网络未实现';
          break;
        case 502:
          error.message = '网络错误';
          break;
        case 503:
          error.message = '服务不可用';
          break;
        case 504:
          error.message = '网络超时';
          break;
        case 505:
          error.message = 'http版本不支持该请求';
          break;
        default:
          error.message = '连接错误' + error.response.status;
      }
      if (error.response.status !== 401) {
        Message({ type: 'error', message: error.message });
      }
    } else {
      Message({ type: 'error', message: '连接到服务器失败' });
    }
    return Promise.reject(error || error.response);
  }
);

export default instance;
